'use strict';

var _ = require('underscore');
var $ = require('js/sw-jquery/sw-jquery');

/**
 *  data-sw-char-case
 *
 *  Text a text input and transforms its character case on keyup
 *
 *  data-sw-char-case="<optional case>"
 *    Defaults to upper
 */

var CASE_MAP = {
  lower: 'toLowerCase',
  upper: 'toUpperCase'
};
var DEFAULT_CASE = 'upper';
var THROTTLE_RATE = 100;

$(function() {
  $('body').on('keyup', '[data-sw-char-case]', _.throttle(function () {
    var $el = $(this);
    var charCase = $el.attr('data-sw-char-case') || DEFAULT_CASE;
    var val = $el.val();
    var charCaseMethod = CASE_MAP[charCase];

    // get the text transformation method name from the case map
    // and invoke it on the string.
    if(_.isFunction(val[charCaseMethod])) {
      val = val[charCaseMethod]();
      $el.val(val);
      $el.trigger('change');
    }

  }, THROTTLE_RATE));
});
